'use strict';
var processInclude = require('base/util');

module.exports = {
    initEvents: function () {
        // events will be init'd on load
        let $tabParent = $('.tabbed-layout');
        let $tabEls = $tabParent.find('a[data-toggle="tab"]');
        $tabEls.each(function () {
            $(this).on('show.bs.tab', function (e) {
                let $tabID = $(e.target).attr('href');
                let $tabContent = $tabParent.find($tabID);

                // hidden carousels
                var $slider = $tabContent.find('.slick-initialized');
                if ($slider.length > 0) {
                    // hide the slider until it is init'd properly
                    $slider.css('opacity', 0);
                    // destroy and reinit slider
                    $slider.slick('unslick');
                    processInclude(require('pagedesigner/experience/carousels'));
                    // show the slider
                    $slider.css('opacity', 1);
                }
            });
        });
    }
};
